import React from 'react';
import { useIntl } from 'react-intl';
import { ApiFilterOperation, Evidence } from '@eas/common-web';
import { EsFileState } from '@enums';
import { useCourtFiles } from '../court-files';
import { useColumns } from '../registry/court-file-registry-columns';

export const COURT_FILES_SHREDDED_IDENTIFIER = 'COURT_FILES_SHREDDED';
export const COURT_FILES_SHREDDED_VERSION = 5;

export function CourtFilesShredded() {
  const intl = useIntl();
  const columns = useColumns();

  const { evidenceBag } = useCourtFiles({
    evidenceProps: {
      identifier: COURT_FILES_SHREDDED_IDENTIFIER,
      version: COURT_FILES_SHREDDED_VERSION,
      tableProps: {
        columns,
        defaultPreFilters: [
          {
            field: 'state.id',
            operation: ApiFilterOperation.EQ,
            value: EsFileState.SHREDDED,
          },
        ],
        tableName: intl.formatMessage({
          id: 'ES__COURT_FILES_SHREDDED__TABLE__TITLE',
          defaultMessage: 'Soudní spisy - Skartované',
        }),
      },
      detailProps: {
        toolbarProps: {
          showBtn: (button) => {
            if (button === 'NEW') {
              return false;
            }
            return true;
          },
        },
      },
    },
  });

  return <Evidence {...evidenceBag} />;
}
